import { useState } from "react";
import StyledWrapper from "./style";

export default function TurnConfirmation() {
  const [clicked, setClicked] = useState(false);
  const declarationId = new URLSearchParams(window.location.search).get(
    "declarationId",
  );
  const isTurnoCancelado = window.location.search.includes("Turno-cancelado");
  const isEfisico = window.location.search.includes("E-F");
  const handleButtonClick = () => {
    if (declarationId) {
      const declarationUrl = `/Declaracion-jurada/${declarationId}`;
      window.open(declarationUrl, "_blank");
      setClicked(true);
    }
  };

  return (
    
    <div className="h-screen bg-[#525151]">
      {!isEfisico ? 
      <><StyledWrapper.Header>
          <div className="w-full bg-[#343030] py-6 px-12">
            <img
              src="/images/Logo_Lavorix_grande.svg"
              alt="LogoLavoris"
              className="h-10" />
            <p className="text-white text-xs">Portal de Clientes</p>
          </div>
        </StyledWrapper.Header><StyledWrapper.Card>
            <StyledWrapper.CardTitle>
              Tu turno se confirmó con éxito
            </StyledWrapper.CardTitle>
            <StyledWrapper.CardContent>
              *Puedes cerrar esta ventana.
            </StyledWrapper.CardContent>
          </StyledWrapper.Card></> :
      <><StyledWrapper.Header>
          <div className="w-full bg-[#343030] py-6 px-12">
            <img
              src="/images/Logo_Lavorix_grande.svg"
              alt="LogoLavoris"
              className="h-10" />
            <p className="text-white text-xs">Portal de Clientes</p>
          </div>
        </StyledWrapper.Header><StyledWrapper.Card>
            <StyledWrapper.CardTitle>
              {isTurnoCancelado
                ? "Turno no disponible"
                : "Tu turno se confirmó con éxito"}
            </StyledWrapper.CardTitle>
            <StyledWrapper.CardContent>
              {isTurnoCancelado
                ? "El turno ha sido cancelado y ya no está disponible para confirmación."
                : "No olvides completar la Declaración Jurada antes de asistir a Lavoris"}
            </StyledWrapper.CardContent>
            <StyledWrapper.CardContent>
              {isTurnoCancelado ? "*Puedes cerrar esta ventana." : null}
            </StyledWrapper.CardContent>
            {isTurnoCancelado ? null : (
              <button
                className="button"
                onClick={handleButtonClick}
                style={{
                  backgroundColor: "#4A81F2",
                  color: "white",
                  textDecoration: "none",
                  padding: "10px 20px",
                  borderRadius: "4px",
                  display: "inline-block",
                  fontWeight: "bold",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  marginTop: "35px",
                }}
              >
                Completar Declaración Jurada
              </button>
            )}
          </StyledWrapper.Card></>
      }
    </div>
  );
}

